/**
 * Created by joerg on 20.05.17.
 */

import {observable,autorun} from 'mobx';
import shortid from 'shortid'
import Utils from '../utils/Utils'
import numeral from 'numeral/numeral'
import 'numeral/locales'
export default class InputModel {
    @observable title;
    @observable value;
    @observable einheit;
    @observable disabled;
    @observable isHidden;
    key;
    isdecimal;
    valsetcb;
    isText;

    constructor(title = "Ohne Titel", value = 0.0, einheit, disabled = false,isdecimal = true,valsetcb=null,isText=false,isHidden=false) {
        this.title = title;
        this.value = value;
        this.einheit = einheit;
        this.disabled = disabled;
        this.key = shortid.generate()
        this.isdecimal = isdecimal;
        this.isText = isText;
        this.isHidden = isHidden;
        if(valsetcb !== null){
           this.valsetcb =  autorun(() => valsetcb(this.value));
        }
    }

    getCombinedVal() {
        numeral.locale('de');
        var fval;
        if(!this.isText){

            if(this.einheit === "€") {
                fval = numeral(Math.round(this.value)).format('0,0[.]00 $');
            }else if(this.einheit === "pro Jahr"){
                fval = numeral(Math.round(this.value)).format('0,0[.]00 ') +'x '+ this.einheit ;
            }else{
                if(this.isdecimal){
                    fval = Utils.rAndF(this.value) +' '+ this.einheit
                }else{
                    fval = Utils.rAndFNoDec(this.value) +' '+ this.einheit
                }
               // fval = numeral(Math.round( (this.value + Number.EPSILON) * 100) / 100).format('0,0[.]0 ') +' '+ this.einheit ;
            }
            return Utils.stripTags(fval.toString());
        }else{
            return this.value.toString();
        }
    }
    getTitleStripped(){
        return Utils.stripTags(this.title || '');
    }
}


// WEBPACK FOOTER //
// ./src/models/InputModel.js